import { useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { AUTH_EVENT } from '../services/auth.js';

export default function ConsentGate() {
  const [documents, setDocuments] = useState([]);
  const [checks, setChecks] = useState([]);
  const [accepted, setAccepted] = useState({ terms: false, privacy: false });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get('/auth/consent/documents')
      .then(({ data }) => {
        setDocuments(data.data.documents || []);
        setChecks(data.data.checks || []);
      })
      .catch((err) => setError(err.message || 'Texty se nepodařilo načíst.'));
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!accepted.terms || !accepted.privacy) {
      setError('Bez obou potvrzení nelze pokračovat.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await api.post('/auth/consent', accepted);
      window.dispatchEvent(new Event(AUTH_EVENT));
    } catch (err) {
      setError(err.message || 'Potvrzení se nepodařilo uložit.');
      setSubmitting(false);
    }
  };

  return (
    <main className="auth">
      <h1 className="auth__title">Aktualizované podmínky</h1>
      <p className="auth__subtitle">
        Než budeš pokračovat, projdi si aktuální informace a potvrď obě položky.
      </p>
      {documents.map((document) => (
        <details key={document.key}>
          <summary>{document.title}</summary>
          <p>{document.text}</p>
        </details>
      ))}
      <form className="auth__form" onSubmit={submit}>
        {checks.map((check) => (
          <label className="auth__label" key={check.key}>
            <span>
              <input
                type="checkbox"
                checked={accepted[check.key] || false}
                onChange={(event) => setAccepted((current) => ({
                  ...current,
                  [check.key]: event.target.checked,
                }))}
              />{' '}
              {check.label}
            </span>
            <small>{check.hint}</small>
          </label>
        ))}
        {error && <p className="auth__error" role="alert">{error}</p>}
        <button className="button button--primary" type="submit" disabled={submitting}>
          {submitting ? 'Ukládám…' : 'Potvrdit a pokračovat'}
        </button>
      </form>
    </main>
  );
}
